import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules"
import totalassure from "../../assets/totalassure.png";
import asianPaintsLogo from "../../assets/APlogo.png";
import AdPopup from "./AdPopup";
import API, { UPLOADS_URL } from "../../services/api";

import "swiper/css";
import { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Card,
  DashboardShell,
  GhostButton,
  KpiCard,
  PrimaryButton,
  ProgressBar,
  SectionHeader,
  StatusBadge,
  palette,
} from "../../components/dashboard/DashboardKit";
import {
  Home, ClipboardList, Star, FileText, Phone,
  Calendar, ArrowRight, X, Camera,
} from "lucide-react";

/* ── NAV — UNCHANGED ── */
const clientNav = [
  { icon: <Home className="w-5 h-5" />, label: "Dashboard", path: "/client-dashboard", key: "dashboard" },
  { icon: <ClipboardList className="w-5 h-5" />, label: "Project Timeline", path: "/project-timeline", key: "timeline" },
   { icon: <Camera className="w-5 h-5" />, label: "Visit Logs",       path: "/visit-logs"         },
  { icon: <Star className="w-5 h-5" />, label: "Feedback", path: "/client-testimonials", key: "testimonials" },
  { icon: <FileText className="w-5 h-5" />, label: "Reports", path: "/client-reports", key: "reports" },
  { icon: <Phone className="w-5 h-5" />, label: "Contact", path: "/contact", key: "contact" },
];

/* ── STATIC DATA — UNCHANGED ── */
const reports = [
  { id: "RPT-001", title: "Site Survey Report", project: "AP-PUNE-001", date: "05 Apr 2026", size: "2.4 MB", status: "Approved" },
  { id: "RPT-002", title: "Material Quality Report", project: "AP-PUNE-001", date: "26 Apr 2026", size: "1.8 MB", status: "Approved" },
  { id: "RPT-003", title: "Progress Report - Week 3", project: "AP-MUM-014", date: "10 May 2026", size: "3.1 MB", status: "Approved" },
  { id: "RPT-004", title: "Inspection Checklist", project: "AP-PUNE-001", date: "15 May 2026", size: "1.2 MB", status: "Pending" },
];

const donutData = [
  { name: "Completed", value: 4, color: palette.green },
  { name: "In Progress", value: 1, color: palette.orange },
  { name: "Upcoming", value: 3, color: palette.faint },
];

export default function ClientDashboard() {
  const navigate = useNavigate();

  /* ── ALL STATE — UNCHANGED ── */
  const [projectInfo, setProjectInfo] = useState({
    project_name: "", project_uid: "", status: "",
    start_date: "", end_date: "",
  });
  const [galleryImages, setGalleryImages] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [timelineData, setTimelineData] = useState([]);
const [ganttView, setGanttView] = useState("day"); // "day" | "month" | "year"

const projectStart = new Date(projectInfo?.start_date || new Date());
const projectEnd   = new Date(projectInfo?.end_date   || new Date());
const totalDays = Math.ceil((projectEnd - projectStart) / (1000 * 60 * 60 * 24)) + 1;

const GANTT_COL_WIDTH = { day: 64, week: 90, month: 110 };
const colWidth = GANTT_COL_WIDTH[ganttView];

const dayHeaders = [];
for (let i = 0; i < totalDays; i++) {
  const d = new Date(projectStart);
  d.setDate(projectStart.getDate() + i);
  dayHeaders.push(new Date(d));
}

const monthHeaders = [];
{
  const cursor = new Date(projectStart.getFullYear(), projectStart.getMonth(), 1);
  const endCursor = new Date(projectEnd.getFullYear(), projectEnd.getMonth(), 1);
  while (cursor <= endCursor) {
    monthHeaders.push(new Date(cursor));
    cursor.setMonth(cursor.getMonth() + 1);
  }
}

const weekHeaders = [];
{
  // Start from the Monday on/before projectStart
  const cursor = new Date(projectStart);
  const day = cursor.getDay();
  const diffToMonday = (day === 0 ? -6 : 1) - day;
  cursor.setDate(cursor.getDate() + diffToMonday);
  while (cursor <= projectEnd) {
    weekHeaders.push(new Date(cursor));
    cursor.setDate(cursor.getDate() + 7);
  }
}

const dateHeaders =
  ganttView === "day" ? dayHeaders :
  ganttView === "month" ? monthHeaders :
  weekHeaders;

const daysPerCol =
  ganttView === "day" ? 1 :
  ganttView === "month" ? 30.4 :
  7;

const formatHeaderLabel = (d) => {
  if (ganttView === "day") {
    return { primary: d.getDate(), secondary: d.toLocaleDateString("en-US", { month: "short" }) };
  }
  if (ganttView === "month") {
    return { primary: d.toLocaleDateString("en-US", { month: "short" }), secondary: String(d.getFullYear()) };
  }
  // week view — show the week's start date, e.g. "14" with month below
  return { primary: d.getDate(), secondary: d.toLocaleDateString("en-US", { month: "short" }) };
};

  const [discussions, setDiscussions] = useState([]);


  const [message, setMessage] = useState("");
  const [topic, setTopic] = useState("Project Progress");

  const userName = localStorage.getItem("name") || "User";
  const userRole = localStorage.getItem("role") || "Client";
  const initials = userName.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);
  const today = new Date().toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  const [dashboard, setDashboard] = useState({ total_projects: 0, total_reports: 0, latest_update: null });

  /* ── ALL EFFECTS & HANDLERS — UNCHANGED ── */
  useEffect(() => {
    loadDashboard(); loadTimeline(); loadDiscussions(); loadProjectInfo(); loadGallery();
  }, []);

  const loadGallery = async () => {
    try {
      const projectId = localStorage.getItem("project_id");

      console.log("PROJECT ID =", projectId);
      console.log(
        "URL =",
        `${API.defaults.baseURL}/client/project-gallery/${projectId}`
      );

      const res = await API.get(
        `/client/project-gallery/${projectId}`
      );

      console.log("GALLERY RESPONSE =", res.data);
      console.log("IMAGES =", res.data.images);

      setGalleryImages(res.data.images || []);
    } catch (error) {
      console.log("Gallery Error:", error);
    }
  };

  const loadDiscussions = async () => {
    try {
      const projectId = localStorage.getItem("project_id");
      const res = await API.get(`/discussions/project/${projectId}`);
      console.log("PROJECT ID =", projectId);
      console.log("FULL RESPONSE =", res.data);
      console.log("DATA =", res.data.data);
      setDiscussions(res.data.data || []);
    } catch (err) { console.error("Discussion Error:", err); }
  };

  const loadDashboard = async () => {
    try {
      const res = await API.get("/client/dashboard");
      console.log("DASHBOARD =", res.data);
      setDashboard(res.data.dashboard);
    } catch (err) { console.error(err); }
  };

  const loadProjectInfo = async () => {
    try {
      const projectId = localStorage.getItem("project_id");
      const res = await API.get(`/client/project-details/${projectId}`);
      console.log("PROJECT INFO =", res.data);
      console.log("PROJECT DATA =", res.data.project);
      setProjectInfo(res.data.project);
    } catch (err) { console.error(err); }
  };

  const loadTimeline = async () => {
    try {
      const projectId = localStorage.getItem("project_id");
      console.log("PROJECT ID =", projectId);
      const res = await API.get(`/client/project-timeline/${projectId}`);
      console.log("TIMELINE =", res.data);
      const data = Array.from(
        new Map(
          (res.data.timeline || []).map(item => [
            item.id,
            { id: item.id, name: item.phase_id, task: item.task_id, start_date: item.start_date, end_date: item.end_date, status: item.status }
          ])
        ).values()
      );
      setTimelineData(data);
      console.log("FIRST TIMELINE ROW", data[0]);
      console.log("TIMELINE JSON =", JSON.stringify(data, null, 2));
    } catch (err) { console.error(err); }
  };

  /* ── ALL DERIVED VALUES — UNCHANGED ── */
  const completed = timelineData.filter(t => t.status === "completed").length;
  const inprogress = timelineData.filter(t => t.status === "in_progress").length;
  const pending = timelineData.filter(t => t.status === "pending").length;
  const pct = timelineData.length > 0 ? Math.round((completed / timelineData.length) * 100) : 0;

  const recentPhase = timelineData.length > 0 ? timelineData[timelineData.length - 1] : null;
  const recentPhases = [...timelineData].sort((a, b) => new Date(b.end_date) - new Date(a.end_date)).slice(0, 4);

  const pieData = [
    { name: "Completed", value: completed, color: "#1A7A42" },
    { name: "In Progress", value: inprogress, color: "#E8640A" },
    { name: "Pending", value: pending, color: "#9070B8" },
  ];

  /* ── STATUS COLOUR HELPERS ── */
  const phaseStatusClasses = (status) =>
    status === "completed" ? "bg-emerald-50 text-emerald-700 border border-emerald-200" :
      status === "in_progress" ? "bg-orange-50  text-orange-700  border border-orange-200" :
        "bg-slate-100  text-slate-500   border border-slate-200";

  const phaseStatusLabel = (status) =>
    status === "completed" ? "Completed" : status === "in_progress" ? "In Progress" : "Upcoming";

  const formatDate = (dateStr) => {
  if (!dateStr) return "—";

  const d = new Date(dateStr);
  return isNaN(d.getTime())
    ? "—"
    : d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
};

 return (
    <>
    <AdPopup />
    <style>{`@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');`}</style>
    <DashboardShell
  portal="Client Portal"
  title={
    <div className="flex items-center gap-6">
      <img
        src={require("../../assets/totalassure.png")}
        alt="TotalAssure"
        className="h-14 md:h-16 w-auto object-contain"
      />
      <img
        src={require("../../assets/APlogo.png")}
        alt="Asian Paints"
        className="h-12 md:h-14 w-auto object-contain"
      />
    </div>
  }
  roleLabel="CLIENT"
  navItems={clientNav}
  user={{ initials, name: userName, role: userRole }}
>

      {/* ══════════════════════════════════════════════
          SECTION 1 — PROJECT HERO CARD
      ══════════════════════════════════════════════ */}
      <div className="relative overflow-hidden rounded-3xl mb-6 p-7 sm:p-8"
        style={{ background: "linear-gradient(135deg,#3D1870 0%,#5C2D91 42%,#E8640A 100%)", boxShadow: "0 16px 56px rgba(92,45,145,0.30)" }}>

        {/* Decorative blobs */}
        <div className="pointer-events-none absolute -right-16 -top-16 w-64 h-64 rounded-full bg-white/[0.05]" />
        <div className="pointer-events-none absolute -left-12 -bottom-16 w-56 h-56 rounded-full bg-white/[0.04]" />
        <div className="pointer-events-none absolute right-24 -bottom-10 w-32 h-32 rounded-full bg-white/[0.03]" />

        {/* Top row: project meta + big % */}
        <div className="relative z-10 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-5 mb-7">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-[10px] font-bold tracking-widest uppercase text-white/50">
                {projectInfo?.project_uid || "N/A"}
              </span>
              {projectInfo?.status && (
                <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-white/15 text-white/80 border border-white/20">
                  {projectInfo.status}
                </span>
              )}
            </div>
<h2 className="text-2xl sm:text-3xl font-black text-white tracking-tight leading-tight mb-1.5" style={{ fontFamily: "'Montserrat',sans-serif" }}>
             {projectInfo?.title || "Project Name"}
            </h2>
            <p className="text-sm text-white/55">
              Started {formatDate(projectInfo?.start_date)}
            </p>
          </div>

          {/* Completion ring */}
          <div className="flex flex-col items-center sm:items-end shrink-0">
          <div className="text-6xl font-black text-white leading-none tracking-tighter" style={{ fontFamily: "'Montserrat',sans-serif" }}>
              {pct}<span className="text-3xl font-bold">%</span>
            </div>
            <span className="text-xs text-white/55 mt-1 font-medium">Overall Complete</span>
          </div>
        </div>

        {/* Progress bar */}
        <div className="relative z-10 mb-2">
          <div className="flex justify-between text-xs font-semibold text-white/70 mb-2">
            <span>Overall Progress</span>
            <span>{completed}/{timelineData.length} phases done</span>
          </div>
          <div className="h-2.5 bg-white/20 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-700"
              style={{ width: `${pct}%`, background: "rgba(255,255,255,0.88)", boxShadow: "0 0 14px rgba(255,255,255,0.35)" }}
            />
          </div>
          <div className="flex justify-between mt-2 text-[11px] font-semibold text-white/65">
            <span>{formatDate(projectInfo?.start_date)}</span>

<span>{formatDate(projectInfo?.end_date)}</span>
          </div>
        </div>

        {/* ── SECTION 5: PROGRESS PHOTOS ── */}



        {galleryImages.length > 0 && (
          <div className="relative z-10 mt-7 pt-6 border-t border-white/10">
            <div className="flex items-center justify-between mb-3.5">
              {/* <div>
                <p className="text-[15px] font-bold text-white">📸 Recent Site Photos</p>
                <p className="text-[11px] text-white/55 mt-0.5">Last {galleryImages.length} project updates</p>
              </div> */}
              <span className="px-3 py-1 rounded-full bg-white/15 border border-white/20 text-white text-[11px] font-semibold">
                {galleryImages.length} Photos
              </span>
            </div>

            <Swiper
              modules={[Autoplay]}
              loop={true}
              spaceBetween={12}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1.2,
                },
                768: {
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 5,
                },
              }}
            >
              {galleryImages.map((img, index) => (
  <SwiperSlide key={index}>
    <div
      onClick={() =>
        setPreviewImage(`${UPLOADS_URL}${img.image}`)
      }
      className="group relative cursor-pointer overflow-hidden rounded-2xl border border-white/15 bg-white/10 backdrop-blur-md"
      style={{ height: 96 }}
    >
      <img
        src={`${UPLOADS_URL}${img.image}`}
        alt=""
        className="w-full h-full object-cover"
        onError={(e) => console.log("Image Error:", e.target.src)}
      />
    </div>
  </SwiperSlide>
))}
            </Swiper>
          </div>
        )}
      </div>

      {/* ── IMAGE PREVIEW MODAL — logic unchanged, visual improved ── */}
      {previewImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 backdrop-blur-sm p-4"
          onClick={() => setPreviewImage(null)}
        >
          <div className="relative max-w-3xl w-full" onClick={e => e.stopPropagation()}>
            <img src={previewImage} alt="Preview" className="w-full rounded-2xl shadow-2xl" />
            <button
              onClick={() => setPreviewImage(null)}
              className="absolute -top-4 -right-4 w-9 h-9 rounded-full bg-white text-slate-800 flex items-center justify-center font-bold text-lg shadow-lg hover:bg-slate-100 transition"
            ><X size={18} /></button>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════
          SECTION 2 + 3 — RECENT ACTIVITY + PHASE PIE
      ══════════════════════════════════════════════ */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-5">

        {/* RECENT PHASES */}
        <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden flex flex-col">
          <div className="flex items-center justify-between px-6 pt-6 pb-4 border-b border-slate-50">
            <div>
              <h3 className="text-lg font-bold text-slate-900">Recent Activity</h3>
              <p className="text-[12px] text-slate-400 mt-0.5">Last {recentPhases.length} phase updates</p>
            </div>
            <span className="px-2.5 py-1 rounded-full bg-violet-50 text-violet-700 text-[11px] font-semibold border border-violet-100">
              {timelineData.length} Phases
            </span>
          </div>

          <div className="flex-1 p-5">
            {recentPhases.length === 0 ? (
              /* Empty state */
              <div className="flex flex-col items-center justify-center py-12 text-center">
                <div className="w-14 h-14 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-center mb-3 text-slate-400"><ClipboardList size={24} /></div>
                <p className="text-sm font-semibold text-slate-500">No phases yet</p>
                <p className="text-xs text-slate-400 mt-1">Project phases will appear here once added.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                {recentPhases.map((phase, index) => (
                  <div key={index}
                    className="group rounded-2xl border border-slate-100 bg-slate-50/60 p-4 hover:border-violet-200 hover:bg-violet-50/40 hover:shadow-md transition-all duration-200 cursor-default">
                    <div className="flex items-start justify-between gap-2 mb-2">
                      <h4 className="text-sm font-bold text-slate-900 leading-snug">{phase.name}</h4>
                      <span className={`shrink-0 px-2 py-0.5 rounded-full text-[10px] font-semibold ${phaseStatusClasses(phase.status)}`}>
                        {phaseStatusLabel(phase.status)}
                      </span>
                    </div>
                    <p className="text-xs text-slate-500 mb-3 line-clamp-2">{phase.task}</p>
                    <div className="flex items-center gap-1.5 text-[10px] text-slate-400 font-medium">
                      <Calendar size={12} className="opacity-60" />
                      {formatDate(phase.end_date)}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="px-5 pb-5">
            <button
              onClick={() => navigate("/project-timeline")}
              className="w-full rounded-xl border border-violet-100 bg-violet-50 py-2.5 text-sm text-violet-700 font-semibold hover:bg-violet-100 hover:border-violet-200 active:scale-[0.98] transition-all duration-150"
            >
              <span className="inline-flex items-center gap-1">View all phases <ArrowRight size={14} /></span>
            </button>
          </div>
        </div>

        {/* PHASE PROGRESS DONUT */}
        <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden flex flex-col">
          <div className="flex items-center justify-between px-6 pt-6 pb-4 border-b border-slate-50">
            <div>
              <h3 className="text-lg font-bold text-slate-900">Phase Progress</h3>
              <p className="text-[12px] text-slate-400 mt-0.5">Live project phase status</p>
            </div>
            <span className="px-2.5 py-1 rounded-full bg-purple-50 text-purple-700 text-[11px] font-semibold border border-purple-100">
              {timelineData.length} Phases
            </span>
          </div>

          <div className="flex-1 px-6 pt-2 pb-4">
            <div className="relative">
              <ResponsiveContainer width="100%" height={220}>
                <PieChart>
                  <Pie data={pieData} dataKey="value" innerRadius={58} outerRadius={86} paddingAngle={4}>
                    {pieData.map((entry, index) => (
                      <Cell key={index} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip
                    contentStyle={{ borderRadius: 12, border: "1px solid #e2e8f0", boxShadow: "0 4px 16px rgba(0,0,0,0.08)", fontSize: 12 }}
                  />
                </PieChart>
              </ResponsiveContainer>
              {/* Centre label */}
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                <div className="text-3xl font-black text-slate-800 leading-none">{timelineData.length}</div>
                <div className="text-[11px] text-slate-400 mt-1 font-medium">Total Phases</div>
              </div>
            </div>

            {/* Legend pills */}
            <div className="grid grid-cols-3 gap-3 mt-3">
              <div className="rounded-2xl bg-emerald-50 border border-emerald-100 p-3 text-center">
                <div className="text-xl font-black text-emerald-600">{completed}</div>
                <div className="text-[11px] text-slate-500 mt-0.5">Completed</div>
              </div>
              <div className="rounded-2xl bg-orange-50 border border-orange-100 p-3 text-center">
                <div className="text-xl font-black text-orange-600">{inprogress}</div>
                <div className="text-[11px] text-slate-500 mt-0.5">In Progress</div>
              </div>
              <div className="rounded-2xl bg-purple-50 border border-purple-100 p-3 text-center">
                <div className="text-xl font-black text-purple-600">{pending}</div>
                <div className="text-[11px] text-slate-500 mt-0.5">Pending</div>
              </div>
            </div>
          </div>
        </div>
      </div>

       {/* ══════════════════════════════════════════════
          SECTION 4 — GANTT CHART (Day / Month / Year)
      ══════════════════════════════════════════════ */}
      <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden">

        {/* Header */}
        <div className="px-6 pt-6 pb-4 border-b border-slate-50 flex items-center justify-between flex-wrap gap-4">
          <div>
            <h3 className="text-lg font-bold text-slate-900">Project  Chart</h3>
            <p className="text-[12px] text-slate-400 mt-0.5">
              {projectInfo?.project_uid || "N/A"} &nbsp;·&nbsp;
              {formatDate(projectInfo?.start_date)}
{" – "}
{formatDate(projectInfo?.end_date)}
            </p>
          </div>

          <div className="flex items-center gap-3 flex-wrap">
            {/* Legend */}
            <div className="hidden sm:flex items-center gap-4">
              {[
                { cls: "bg-emerald-500", label: "Completed" },
                { cls: "bg-violet-600", label: "In Progress" },
                { cls: "bg-slate-200", label: "Upcoming" },
              ].map(l => (
                <div key={l.label} className="flex items-center gap-1.5 text-[11px] text-slate-500 font-medium">
                  <span className={`w-2.5 h-2.5 rounded-sm ${l.cls}`} />
                  {l.label}
                </div>
              ))}
            </div>

            {/* View mode toggle: Day / Month / week */}
           <div className="flex items-center gap-1 bg-slate-100 rounded-xl p-1">
              {["day", "week", "month"].map((mode) => (
                <button
                  key={mode}
                  onClick={() => setGanttView(mode)}
                  className={`px-3.5 py-1.5 rounded-lg text-xs font-semibold capitalize transition-all duration-150 ${
                    ganttView === mode
                      ? "bg-white text-violet-700 shadow-sm"
                      : "text-slate-500 hover:text-slate-700"
                  }`}
                >
                  {mode}
                </button>
              ))}
            </div>

            <button
              onClick={() => navigate("/project-timeline")}
              className="px-4 py-1.5 rounded-xl bg-violet-50 border border-violet-100 text-violet-700 text-xs font-semibold hover:bg-violet-100 transition"
            >
              <span className="inline-flex items-center gap-1">View All <ArrowRight size={13} /></span>
            </button>
          </div>
        </div>

        {/* Chart body */}
        <div className="overflow-auto p-4" style={{ maxHeight: 520 }}>
          <div style={{ minWidth: 260 + dateHeaders.length * colWidth }}>

            {/* Column header row */}
            <div
              className="grid sticky top-0 z-10 bg-white border-b border-slate-100 rounded-t-xl overflow-hidden"
              style={{ gridTemplateColumns: `260px repeat(${dateHeaders.length}, ${colWidth}px)` }}
            >
              <div className="text-xs font-bold text-slate-500 uppercase tracking-wider p-3 border-r border-slate-100 bg-slate-50 flex items-center">
                Task Name
              </div>
              {dateHeaders.map((d, idx) => {
                const { primary, secondary } = formatHeaderLabel(d);
                return (
                  <div
                    key={idx}
                    className="border-r border-slate-100 text-center py-2.5 bg-slate-50"
                  >
                    <div className="text-xs font-bold text-slate-700">{primary}</div>
                    {secondary && <div className="text-[10px] text-slate-400">{secondary}</div>}
                  </div>
                );
              })}
            </div>

            {/* Data rows */}
            {timelineData.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-16 text-center border border-t-0 border-slate-100 rounded-b-xl">
                <div className="mb-3 text-slate-300"><Calendar size={30} /></div>
                <p className="text-sm font-semibold text-slate-500">No timeline data</p>
                <p className="text-xs text-slate-400 mt-1">Gantt entries will appear once phases are assigned.</p>
              </div>
            ) : timelineData.map((phase) => {
              const taskStart = new Date(phase.start_date);
              const taskEnd = new Date(phase.end_date);

              const startOffsetDays = Math.max(0, Math.floor((taskStart - projectStart) / (1000 * 60 * 60 * 24)));
              const durationDays = Math.max(1, Math.floor((taskEnd - taskStart) / (1000 * 60 * 60 * 24)) + 1);

              // Convert day-based offset/duration into the active view's column units
              const startOffsetCols = startOffsetDays / daysPerCol;
              const durationCols = Math.max(durationDays / daysPerCol, ganttView === "day" ? 1 : 0.35);

              const barBg =
                phase.status === "completed" ? "linear-gradient(90deg,#059669,#34d399)" :
                  phase.status === "in_progress" ? "linear-gradient(90deg,#6d28d9,#8b5cf6)" :
                    "linear-gradient(90deg,#cbd5e1,#e2e8f0)";

              const barTextColor = phase.status === "pending" ? "#64748b" : "#fff";

              return (
                <div
                  key={phase.id}
                  className="grid border-b border-slate-50 hover:bg-slate-50/60 transition-colors min-h-[100px]"
                  style={{ gridTemplateColumns: `260px repeat(${dateHeaders.length}, ${colWidth}px)` }}
                >
                  {/* Label cell */}
                  <div className="p-4 border-r border-slate-100 flex flex-col justify-center bg-white">
                    <div className="text-[13px] font-bold text-slate-800 mb-1">{phase.name}</div>
                    <div className="text-[11px] text-slate-400 mb-2">
                      {formatDate(phase.start_date)} – {formatDate(phase.end_date)}
                    </div>
                    <span className={`self-start px-2 py-0.5 rounded-md text-[10px] font-semibold ${phaseStatusClasses(phase.status)}`}>
                      {phaseStatusLabel(phase.status)}
                    </span>
                  </div>

                  {/* Bar cell */}
                  <div
                    className="relative"
                    style={{ gridColumn: `2 / ${dateHeaders.length + 2}`, height: 100 }}
                  >
                    {/* Grid lines */}
                    <div className="absolute inset-0 flex pointer-events-none">
                      {dateHeaders.map((_, idx) => (
                        <div key={idx} style={{ width: colWidth }} className="border-r border-slate-100/80 flex-shrink-0" />
                      ))}
                    </div>

                    {/* Bar */}
                    <div
                      className="absolute flex items-center px-3 rounded-xl text-[11px] font-semibold shadow-md overflow-hidden whitespace-nowrap"
                      style={{
                        top: 34,
                        height: 32,
                        left: startOffsetCols * colWidth,
                        width: Math.max(durationCols * colWidth, 40),
                        background: barBg,
                        color: barTextColor,
                      }}
                      title={`${phase.task} (${formatDate(phase.start_date)} – ${formatDate(phase.end_date)})`}
                    >
                      <span className="truncate">{phase.task}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

  </DashboardShell>
    </>
  );
}